const e=30,o=2e3;export{e as countdownTime,o as delay};
